import qs from "qs";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import { Filter } from "~/features/filter";
import { useGetLocationData } from "~/hooks/locationData";

import { regMenFilterFields } from "./fields";

const DEFAULT_SELECT_REPORT = "reportYear";

const getDefaultParams = () => ({
  SelectReport: DEFAULT_SELECT_REPORT,
});

const RegMenFilter = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { SelectReport } = useGetLocationData() as Record<string, unknown>;
  const reportType = String(SelectReport || DEFAULT_SELECT_REPORT);

  const fields = useMemo(
    () => regMenFilterFields(t, reportType),
    [t, reportType],
  );

  // Дефолт старой формы (defaultValues useForm): тип отчёта «по периоду» —
  // подставляем в URL при первом входе, если значение не задано явно.
  useEffect(() => {
    const params = location.search ? qs.parse(location.search.slice(1)) : {};
    const defaults = getDefaultParams();
    const missing = Object.keys(defaults).filter((key) => !params[key]);
    if (missing.length) {
      history.replace({
        search: qs.stringify({
          ...params,
          ...missing.reduce(
            (acc, key) => ({ ...acc, [key]: defaults[key] }),
            {},
          ),
        }),
      });
    }
  }, []);

  // Кнопки «Показать»/«Сбросить» скрыты: фильтр применяется в URL сразу
  // при изменении поля, а формирование/выгрузка отчёта — отдельными
  // кнопками страницы.
  return <Filter.Root fields={fields} alwaysShow columns={3} hideActions />;
};

export default RegMenFilter;
